import { Inject, Injectable } from '@angular/core';
import {
  AllowedVal,
  AttributeStateService,
  CoreConfig,
  CoreConfigService,
  HttpService
} from '@ntap/core';
import { Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshableAttributeStateService extends AttributeStateService {
  private subjectsByAttributeName: Record<
    string,
    [
      { attributeMetadata: any; objectData: any; viewName: string },
      ReplaySubject<AllowedVal[]>
    ]
  > = {};

  constructor(
    httpService: HttpService,
    @Inject(CoreConfigService) config: CoreConfig
  ) {
    super(httpService, config);
  }

  override getAllowedValues(
    attributeMetadata: any,
    objectData: any,
    viewName: string
  ): Observable<AllowedVal[]> {
    let lastConfigAndSubject =
      this.subjectsByAttributeName[attributeMetadata.name];
    if (!lastConfigAndSubject) {
      const newSubject = new ReplaySubject<AllowedVal[]>(1);
      this.subjectsByAttributeName[attributeMetadata.name] = [
        { attributeMetadata, objectData, viewName },
        newSubject
      ];
      lastConfigAndSubject =
        this.subjectsByAttributeName[attributeMetadata.name];
    }
    return super.getAllowedValues(attributeMetadata, objectData, viewName).pipe(
      tap((response) => {
        lastConfigAndSubject[1].next(response);
      })
    );
  }

  public refreshAllowedValues(attributeName: string): Observable<AllowedVal[]> {
    const lastConfigAndSubject = this.subjectsByAttributeName[attributeName];
    const lastConfig = lastConfigAndSubject[0];
    return this.getAllowedValues(
      lastConfig.attributeMetadata,
      lastConfig.objectData,
      lastConfig.viewName
    );
  }
}
